var React = require('react');

function Keg (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("ellipse",{"className":"a","cx":"12","cy":"4.125","rx":"7.549","ry":"3.375","key":1}),React.createElement("path",{"className":"a","d":"M20.884,9.485A14.753,14.753,0,0,1,12,12.116,14.753,14.753,0,0,1,3.116,9.485","key":2}),React.createElement("path",{"className":"a","d":"M20.7,15.51A14.942,14.942,0,0,1,12,18a14.942,14.942,0,0,1-8.7-2.49","key":3}),React.createElement("path",{"className":"a","d":"M8.625,3.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375","key":4}),React.createElement("path",{"className":"a","d":"M4.5,3.75a23.433,23.433,0,0,0,0,16.5c.75,1.5,3.358,3,7.5,3s6.75-1.5,7.5-3a23.433,23.433,0,0,0,0-16.5","key":5})]);
}

Keg.defaultProps = {"id":"Regular","viewBox":"0 0 24 24"};

module.exports = Keg;

Keg.default = Keg;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/keg.svg
// module id = 1072
// module chunks = 0